import type { Story } from '@/store/story-types'

export const CREATOR_PORTFOLIO_STORY: Story = {
  id: 'creator-portfolio-1',
  name: 'Creator Portfolio',
  narrative: 'A visual portfolio and showcase for designers and developers, featuring a project gallery, skills overview, and contact section to attract clients and collaborators.',
  goals: ['Present creator brand', 'Showcase project gallery', 'Highlight skills', 'Enable client contact'],
  lifecycle: 'building',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 6, linkedPageId: 'home', description: 'Portfolio home with navbar, hero, project gallery, skills, contact, and footer',
      blockRef: { category: 'portfolio', blockId: 'portfolio-hero' } },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Showcase',
      description: 'Visitor sees the creator portfolio hero',
      steps: [
        { type: 'given', text: 'the visitor opens the portfolio' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the hero section with creator name, tagline, and featured visual is visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Browse Works',
      description: 'Visitor explores the project gallery',
      steps: [
        { type: 'given', text: 'the visitor is on the portfolio' },
        { type: 'when', text: 'they scroll to the project gallery section' },
        { type: 'then', text: 'project cards with thumbnails, titles, and categories are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'View Skills',
      description: 'Visitor reviews the skills section',
      steps: [
        { type: 'given', text: 'the visitor is on the portfolio' },
        { type: 'when', text: 'they scroll to the skills section' },
        { type: 'then', text: 'skills with labels and visual indicators are shown', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Contact Creator',
      description: 'Visitor reaches out via the contact section',
      steps: [
        { type: 'given', text: 'the visitor wants to collaborate or hire' },
        { type: 'when', text: 'they scroll to the contact section' },
        { type: 'then', text: 'a contact form or social links are displayed', linkedPageId: 'home' },
        { type: 'and', text: 'the form submits the inquiry', linkedFlowId: 'contactCreator' },
      ],
    },
  ],
}
